import React from "react";
import { separate } from "../../Functions/NumberSeprator";
import Style from "./FactorList.module.css";

const ShoppingList = (props) => {
  return (
    <li className={Style.ShoppingList}>
      <div className={Style.topHold}>
        <p className={props.HideCounter ? Style.WidthHolder : null}>
          {" "}
          {props.name} <span>({props.count} عدد)</span>{" "}
        </p>
        <div className={Style.PriceList}>
          <strong style={{ color: "green" }}>
            {separate(props.price)}
            <span>تومان</span>
          </strong>
        </div>
      </div>
      <div className={Style.feePart}>
        <p>کارمزد محصول :</p>
        <strong style={{ color: "#d01818" }}>
          {separate(props.fee)}
          <span>تومان</span>
        </strong>
      </div>
    </li>
  );
};

export default ShoppingList;
